import { render, staticRenderFns } from "./ManageCitiesPage.vue?vue&type=template&id=65677c81&"
import script from "./ManageCitiesPage.vue?vue&type=script&lang=js&"
export * from "./ManageCitiesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports